var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "url(#paint0_linear_2173_20278)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2184 25V22.536H11.3324V19.742L16.3264 9.16H19.7584L14.7644 19.742H18.2184V15.782H21.2544V19.742H22.6624V22.536H21.2544V25H18.2184Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 39.7305C24.5 35.8761 18.9316 33.8868 17.0522 30.3122L16.9826 30.25L16.9478 30.3122C15.0684 33.8868 9.5 35.8761 9.5 39.7305C9.5 42.9631 14.268 44.2065 16.5998 41.5022C16.6346 41.3779 16.5998 42.3726 16.4258 42.9321C15.8689 44.5795 13.8503 47.004 12.8759 47.75C14.2332 46.7242 19.6972 46.7242 21.0545 47.75C20.08 47.004 18.1659 44.6727 17.5046 42.9321C17.3654 42.4347 17.2958 41.9685 17.261 41.4711C19.558 44.393 24.5 43.0253 24.5 39.7305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 60.3148C50.5 53.377 40.4768 49.7962 37.094 43.3619L36.9687 43.25L36.906 43.3619C33.5232 49.7962 23.5 53.377 23.5 60.3148C23.5 66.1337 32.0824 68.3717 36.2796 63.504C36.3422 63.2802 36.2796 65.0706 35.9664 66.0777C34.964 69.0431 31.3306 73.4072 29.5766 74.75C32.0197 72.9036 41.855 72.9036 44.2981 74.75C42.5441 73.4072 39.0986 69.2109 37.9084 66.0777C37.6578 65.1825 37.5325 64.3432 37.4698 63.448C41.6044 68.7074 50.5 66.2456 50.5 60.3148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_20278",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4S);
export default __webpack_public_path__ + "static/media/4s.a8fe6b94e2460c71bd489c9ab9942667.svg";
export { ForwardRef as ReactComponent };